var _rect, _rect2, _circle, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSwapIconNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 463,
    height: 27,
    viewBox: "0 0 463 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 247,
    y: 16,
    width: 0.999991,
    height: 216,
    transform: "rotate(-90 247 16)",
    fill: "#DDDDDD"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 16,
    width: 0.999991,
    height: 216,
    transform: "rotate(-90 0 16)",
    fill: "#DDDDDD"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 231.297,
    cy: 13.4515,
    r: 13.4514,
    transform: "rotate(-90 231.297 13.4515)",
    fill: "#1A2CCE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M233.319 16.8865C233.27 16.7863 233.193 16.7016 233.096 16.6422C232.999 16.5828 232.887 16.5511 232.772 16.5508L230.95 16.5508L230.95 11.8397C230.95 11.6835 230.886 11.5338 230.772 11.4233C230.658 11.3129 230.503 11.2508 230.342 11.2508L229.127 11.2508C228.966 11.2508 228.811 11.3129 228.697 11.4233C228.584 11.5338 228.52 11.6835 228.52 11.8397L228.52 16.5508L226.697 16.5508C226.58 16.551 226.466 16.5837 226.368 16.6452C226.27 16.7066 226.192 16.7941 226.144 16.8972C226.096 17.0004 226.079 17.1148 226.097 17.2267C226.114 17.3386 226.164 17.4434 226.241 17.5284L229.419 21.0617C229.476 21.1245 229.546 21.1749 229.624 21.2094C229.703 21.2439 229.788 21.2618 229.874 21.2619C229.964 21.2598 230.051 21.2386 230.131 21.1999C230.211 21.1613 230.281 21.106 230.336 21.0381L233.234 17.5048C233.307 17.4198 233.353 17.3168 233.368 17.2075C233.383 17.0982 233.366 16.9869 233.319 16.8865ZM231.011 9.14851C231.06 9.24872 231.137 9.3334 231.234 9.39279C231.331 9.45218 231.443 9.48386 231.557 9.48417L233.38 9.48417L233.38 14.1953C233.38 14.3515 233.444 14.5012 233.558 14.6117C233.672 14.7221 233.826 14.7842 233.988 14.7842L235.203 14.7842C235.364 14.7842 235.518 14.7221 235.632 14.6117C235.746 14.5012 235.81 14.3515 235.81 14.1953L235.81 9.48417L237.633 9.48417C237.75 9.48403 237.864 9.45128 237.962 9.38984C238.06 9.3284 238.138 9.24088 238.186 9.13775C238.234 9.03462 238.25 8.92024 238.233 8.80831C238.216 8.69638 238.166 8.59164 238.089 8.50662L234.911 4.97329C234.854 4.91048 234.784 4.86013 234.705 4.82561C234.627 4.79109 234.542 4.77318 234.455 4.77307C234.366 4.77522 234.279 4.79638 234.199 4.83506C234.119 4.87374 234.049 4.92897 233.994 4.99685L231.096 8.53017C231.023 8.61518 230.977 8.71821 230.962 8.82753C230.947 8.93685 230.964 9.04806 231.011 9.14851Z",
    fill: "#FBFBFB"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwapIconNew);
export default __webpack_public_path__ + "static/media/swap_icon_new.9353e261e2336488742b6325ff260203.svg";
export { ForwardRef as ReactComponent };